import styled from 'styled-components';

export const Container = styled.a`
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  cursor: pointer;

  @media (min-width: 1200px) {
    padding-left: 30px;
  }
`;

export const Conteudo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 1200px) {
    flex-direction: row;
  }
`;

export const ImagemCartaz = styled.div`
  position: relative;
  width: 180px;
  aspect-ratio: 2 / 3;
  border-radius: 2px;
  overflow: hidden;

  box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.08);
`;

export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  width: 100%;

  @media (min-width: 1200px) {
    padding: 20px;
    align-items: flex-start;
  }
`;

export const TextoNota = styled.div`
  font-family: 'Quicksand';
  font-size: 20px;
  text-transform: uppercase;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.GREY};
  margin-bottom: 10px;
`;

export const Avaliacao = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
  box-sizing: border-box;
  padding: 40px;
  border-radius: 10px;
  width: 100%;
  align-items: center;

  @media (min-width: 1200px) {
    margin-left: -120px;
  }

  img {
    width: 40px !important;
  }
`;

export const Rodape = styled.div`
  padding-top: 20px;
  font-family: 'Quicksand';
  font-size: 16px;
  line-height: 25px;
  color: ${({ theme }) => theme.colors.GREY};
`;

export const Nota = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
`;

export const Diretor = styled.div``;

export const Tempo = styled.div``;

export const GenerosContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

export const PlataformasContainer = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (min-width: 1200px) {
    margin-left: -120px;
  }
`;

export const PlataformaImagem = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
`;

export const Usuario = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

export const ImagemPerfil = styled.div`
  position: relative;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.accent.accent_alpha[7]};
  margin-right: 10px;
`;
